export const getSellerOfferFeedbackPanel = ({
  isAssignedToAnotherSeller,
  lockOfferEditing,
}) => ({
  className: `seller-offer-feedback-card ${
    isAssignedToAnotherSeller ? "is-assigned" : lockOfferEditing ? "is-accepted" : "is-editable"
  }`,
  tone: isAssignedToAnotherSeller ? "danger" : lockOfferEditing ? "success" : "muted",
  eyebrow: "La tua proposta",
  title: isAssignedToAnotherSeller
    ? "Ordine assegnato a un altro venditore"
    : lockOfferEditing
    ? "Offerta accettata"
    : "Offerta gia inviata",
  description: isAssignedToAnotherSeller
    ? "Il cliente ha scelto un altro venditore. La tua proposta resta in storico ma non è più modificabile dal tuo pannello."
    : lockOfferEditing
    ? "Il cliente ha selezionato la tua offerta. Da qui puoi solo monitorare il pagamento e l'avanzamento dell'ordine."
    : "Hai gia inviato un'offerta per questa richiesta. Puoi ancora aggiornare i prezzi prima che il cliente scelga una proposta.",
});

export const getSellerOrderStatePanel = ({
  isAssignedToAnotherSeller,
  isInProgress,
  isPaid,
  isPaymentPending,
  isSellerAccepted,
}) => ({
  className: `seller-payment-state-panel ${
    isAssignedToAnotherSeller ? "is-assigned" : isPaid || isInProgress ? "is-paid" : "is-pending"
  }`,
  tone: isAssignedToAnotherSeller ? "danger" : isPaid || isInProgress ? "success" : "warning",
  eyebrow: "Stato ordine",
  title: isAssignedToAnotherSeller
    ? "Ordine assegnato a un altro venditore"
    : isInProgress
    ? "Ordine preso in carico"
    : isPaid
    ? "Pagamento ricevuto"
    : isPaymentPending
    ? "Pagamento in verifica"
    : isSellerAccepted
    ? "Offerta accettata"
    : "Offerta chiusa",
  description: isAssignedToAnotherSeller
    ? "Il cliente ha scelto e confermato un'altra proposta. Questa richiesta non è piu operabile dal tuo pannello."
    : isInProgress
    ? "Hai gia preso in carico l'ordine. Ora puoi preparare la consegna o il ritiro secondo il tuo flusso operativo."
    : isPaid
    ? "Il cliente ha completato il pagamento. Puoi passare alla presa in carico operativa della richiesta."
    : isPaymentPending
    ? "Il cliente ha terminato il checkout su Stripe. Restiamo in attesa della conferma webhook prima di sbloccare l'operatività."
    : isSellerAccepted
    ? "Il cliente ha selezionato la tua offerta. In attesa dell'avvio del pagamento."
    : "Il cliente ha già scelto un'altra proposta. Le modifiche alla tua offerta sono disabilitate.",
});

export const getSellerSubmitOfferButtonState = ({
  isSubmitting,
  lockOfferEditing,
  isInProgress,
  isPaid,
  isPaymentPending,
}) => ({
  icon: isSubmitting ? "fa-circle-o-notch fa-spin" : lockOfferEditing ? "fa-lock" : "fa-paper-plane",
  label: lockOfferEditing
    ? isInProgress
      ? "Ordine in lavorazione"
      : isPaid
      ? "Richiesta pagata"
      : isPaymentPending
      ? "Pagamento in verifica"
      : "Offerta bloccata"
    : isSubmitting
    ? "Invio offerta..."
    : "Invia offerta",
});

export const getCustomerOrderStatusPanel = ({
  richiesta,
  acceptedOffer,
  isInProgress,
  isPaid,
  isPaymentPending,
}) => {
  if (isInProgress) {
    return {
      tone: "is-paid",
      sharedTone: "success",
      eyebrow: "Ordine in lavorazione",
      title: "Il venditore ha preso in carico l'ordine",
      description: getInProgressDescription(getOrderFulfillmentPolicy(richiesta)),
      icon: "fa-briefcase",
    };
  }

  if (isPaid) {
    return {
      tone: "is-paid",
      sharedTone: "success",
      eyebrow: "Ordine confermato",
      title: "Pagamento completato",
      description:
        "La tua richiesta è stata confermata con successo. Il venditore può ora prendere in carico l'ordine e procedere con la preparazione.",
      icon: "fa-check-circle",
    };
  }

  if (isPaymentPending) {
    return {
      tone: "is-pending",
      sharedTone: "warning",
      eyebrow: "Verifica pagamento",
      title: "Pagamento in verifica",
      description:
        "Stripe ha completato il checkout, ma stiamo ancora aspettando la conferma definitiva del pagamento. Fino ad allora le operazioni restano bloccate.",
      icon: "fa-circle-o-notch",
    };
  }

  if (acceptedOffer) {
    return {
      tone: "is-selected",
      sharedTone: "info",
      eyebrow: "Offerta selezionata",
      title: "Pronta per il pagamento",
      description:
        "Hai già scelto l'offerta migliore. Completa il pagamento per confermare definitivamente l'ordine e sbloccare la fase operativa.",
      icon: "fa-credit-card",
    };
  }

  if ((richiesta?.offerte || []).length > 0) {
    return {
      tone: "is-active",
      sharedTone: "info",
      eyebrow: "Confronto attivo",
      title: "Offerte disponibili",
      description:
        "Hai già ricevuto una o piu proposte dal marketplace. Confrontale e scegli quella piu vantaggiosa per proseguire.",
      icon: "fa-balance-scale",
    };
  }

  return {
    tone: "is-waiting",
    sharedTone: "muted",
    eyebrow: "Marketplace in ascolto",
    title: "In attesa di offerte",
    description:
      "La richiesta è stata inviata correttamente. Stiamo raccogliendo le disponibilita dei venditori prima di mostrarti le prime offerte.",
    icon: "fa-hourglass-half",
  };
};

export const getCustomerOfferEyebrow = ({
  isPaid,
  isAccepted,
  isPaymentPending,
  isLockedByOtherOffer,
  isBest,
}) => {
  if (isPaid && isAccepted) {
    return "Pagamento completato";
  }

  if (isPaymentPending && isAccepted) {
    return "Pagamento in verifica";
  }

  if (isAccepted) {
    return "Offerta selezionata";
  }

  if (isLockedByOtherOffer) {
    return "Offerta non selezionata";
  }

  if (isBest) {
    return "Proposta suggerita";
  }

  return "Proposta alternativa";
};

export const getCustomerSummaryPanel = ({
  acceptedOffer,
  isPaid,
  isPaymentPending,
  offerteCount,
  bestOfferTotal,
}) => {
  if (acceptedOffer) {
    return {
      title: "Offerta gia selezionata",
      description: `Hai selezionato ${acceptedOffer.displayLabel || "questa proposta"}. ${
        isPaid
          ? "Il pagamento è stato registrato con successo."
          : isPaymentPending
          ? "Il pagamento è in verifica da parte di Stripe."
          : "Completa il pagamento per confermare definitivamente l'ordine."
      }`,
    };
  }

  if (offerteCount > 0) {
    return {
      title: "Confronto rapido",
      description: `Hai già ricevuto ${offerteCount} offerte per questa richiesta. La migliore proposta attuale è ${bestOfferTotal}.`,
    };
  }

  return {
    title: "Confronto rapido",
    description:
      "Non ci sono ancora offerte disponibili. Il marketplace continua a cercare la soluzione migliore per te.",
  };
};

export const getCustomerRequestHighlightPanel = ({
  acceptedOffer,
  bestOffer,
  offerteCount,
  isPaid,
  isInProgress,
  isPaymentPending,
  fulfillmentPolicy,
  formatPrice,
  acceptedOfferSavings,
  bestOfferSavings,
}) => {
  if (acceptedOffer) {
    return {
      tone: "info",
      eyebrow: isInProgress
        ? "Ordine in lavorazione"
        : isPaid
        ? "Pagamento completato"
        : isPaymentPending
        ? "Pagamento in verifica"
        : "Offerta accettata",
      title: isInProgress
        ? "Il venditore ha preso in carico il tuo ordine"
        : isPaid
        ? "Hai confermato e pagato l'offerta selezionata"
        : isPaymentPending
        ? "Hai completato il checkout, attendiamo la conferma finale"
        : "Hai selezionato un'offerta per questa richiesta",
      description: isInProgress
        ? getInProgressDescription(fulfillmentPolicy)
        : isPaid
        ? `Pagamento confermato per ${formatPrice(acceptedOffer.prezzoTotale)}.`
        : isPaymentPending
        ? `L'offerta selezionata vale ${formatPrice(acceptedOffer.prezzoTotale)}. Ti aggiorneremo appena Stripe confermera il pagamento.`
        : `Offerta selezionata da ${formatPrice(acceptedOffer.prezzoTotale)}.`,
      metrics: [
        { label: "Totale selezionato", value: formatPrice(acceptedOffer.prezzoTotale) },
        ...(acceptedOfferSavings?.savings > 0
          ? [{ label: "Sconto totale", value: `-${acceptedOfferSavings.percent}%`, helper: `Risparmi ${formatPrice(acceptedOfferSavings.savings)}` }]
          : []),
        ...(fulfillmentPolicy ? [{ label: "Evasione", value: fulfillmentPolicy.shortLabel, helper: fulfillmentPolicy.helper }] : []),
      ],
    };
  }

  if (bestOffer) {
    return {
      tone: "info",
      eyebrow: "Offerte ricevute",
      title: `Hai già ricevuto ${offerteCount} offerte per questa richiesta`,
      description:
        bestOfferSavings?.savings > 0
          ? `Migliore proposta attuale ${formatPrice(bestOffer.prezzoTotale)} con sconto del ${bestOfferSavings.percent}% e risparmio di ${formatPrice(bestOfferSavings.savings)}.`
          : `Migliore proposta attuale ${formatPrice(bestOffer.prezzoTotale)}.`,
      metrics: [
        { label: "Miglior totale", value: formatPrice(bestOffer.prezzoTotale) },
        ...(bestOfferSavings?.savings > 0
          ? [{ label: "Sconto", value: `-${bestOfferSavings.percent}%`, helper: `Risparmi ${formatPrice(bestOfferSavings.savings)}` }]
          : []),
      ],
    };
  }

  return {
    tone: "muted",
    eyebrow: "Marketplace in ascolto",
    title: "Richiesta in attesa di offerte",
    description: "Il marketplace sta ancora raccogliendo le migliori proposte per te.",
    icon: "fa-hourglass-half",
  };
};

export const getOfferFulfillmentLabel = (offerta) => {
  if (offerta?.evasioneStimata === "OGGI") {
    return "Oggi per ordini entro le 15";
  }

  if (offerta?.evasioneStimata === "GIORNO_LAVORATIVO_SUCCESSIVO") {
    return "Giorno lavorativo successivo";
  }

  if (Number(offerta?.tempoStimatoMin || 0) > 0) {
    return `${Number(offerta.tempoStimatoMin)} min`;
  }

  return "N/D";
};

export const getOfferFulfillmentShortLabel = (offerta) => {
  if (offerta?.evasioneStimata === "OGGI") {
    return "OGGI";
  }

  if (offerta?.evasioneStimata === "GIORNO_LAVORATIVO_SUCCESSIVO") {
    return "GIORNO LAVORATIVO SUCCESSIVO";
  }

  if (Number(offerta?.tempoStimatoMin || 0) > 0) {
    return `${Number(offerta.tempoStimatoMin)} min`;
  }

  return "N/D";
};

export const shouldShowCustomerFulfillment = ({ isInProgress }) => Boolean(isInProgress);

const getInProgressDescription = (fulfillmentPolicy) => {
  if (!fulfillmentPolicy) {
    return "L'ordine è ora in preparazione. Sarà evaso il giorno lavorativo successivo.";
  }

  return fulfillmentPolicy.shortLabel === "OGGI"
    ? "L'ordine è ora in preparazione. Sarà evaso in data odierna."
    : "L'ordine è ora in preparazione. Sarà evaso il giorno lavorativo successivo.";
};

const getOrderReferenceTimestamp = (richiesta) => {
  const tracking = Array.isArray(richiesta?.tracking) ? richiesta.tracking : [];
  const paidOrAssignedStep = [...tracking]
    .reverse()
    .find((item) => ["PAGATA", "IN_LAVORAZIONE"].includes(item?.stato));

  return (
    richiesta?.pagamento?.completedAt ||
    richiesta?.pagamento?.updatedAt ||
    paidOrAssignedStep?.timestamp ||
    richiesta?.updatedAt ||
    richiesta?.createdAt ||
    null
  );
};

export const getOrderFulfillmentPolicy = (richiesta) => {
  const timestamp = getOrderReferenceTimestamp(richiesta);
  if (!timestamp) {
    return null;
  }

  const referenceDate = new Date(timestamp);
  if (Number.isNaN(referenceDate.getTime())) {
    return null;
  }

  if (referenceDate.getHours() < 15) {
    return {
      shortLabel: "OGGI",
      label: "Oggi",
      helper: "Per ordini confermati entro le 15.",
    };
  }

  return {
    shortLabel: "GIORNO LAVORATIVO SUCCESSIVO",
    label: "Giorno lavorativo successivo",
    helper: "Per ordini confermati dopo le 15.",
  };
};

export const getOfferFulfillmentRank = (offerta) => {
  if (offerta?.evasioneStimata === "OGGI") {
    return 1;
  }

  if (offerta?.evasioneStimata === "GIORNO_LAVORATIVO_SUCCESSIVO") {
    return 2;
  }

  if (Number(offerta?.tempoStimatoMin || 0) > 0) {
    return 100 + Number(offerta.tempoStimatoMin);
  }

  return Number.MAX_SAFE_INTEGER;
};



